import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=4a79be80&scoped=true"
import script from "./UserIndex.vue?vue&type=script&lang=js"
export * from "./UserIndex.vue?vue&type=script&lang=js"
import style0 from "./UserIndex.vue?vue&type=style&index=0&id=4a79be80&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79be80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a79be80')) {
      api.createRecord('4a79be80', component.options)
    } else {
      api.reload('4a79be80', component.options)
    }
    module.hot.accept("./UserIndex.vue?vue&type=template&id=4a79be80&scoped=true", function () {
      api.rerender('4a79be80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/user/UserIndex.vue"
export default component.exports